import { RootState } from 'src/config/rootStore';

import { Language } from 'src/modules/languages/models/language';

import { createSelector } from 'reselect';

const sortLanguages = (languageA: Language, languageB: Language) => {
    if (languageA.displayOrder > languageB.displayOrder) {
        return 1;
    } else if (languageA.displayOrder < languageB.displayOrder) {
        return -1;
    } else if (languageA.displayName.toLowerCase() > languageB.displayName.toLowerCase()) {
        return 1;
    } else if (languageA.displayName.toLowerCase() < languageB.displayName.toLowerCase()) {
        return -1;
    } else {
        return 0;
    }
};

export const getLanguages = (state: RootState) => state.languages || [];

export const getSortedLanguages = createSelector(getLanguages, languages =>
    languages.sort((a, b) => sortLanguages(a, b)),
);
